/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  ExpandableOverviewItem,
  RequestCaptureForm
} from '../'

export class RequestCapture extends React.PureComponent {
  static propTypes = {
    requestRun: PropTypes.shape({
      id: PropTypes.string,
      sources: PropTypes.array,
      requesttype: PropTypes.object,
      capturedBy: PropTypes.object,
      validatedBy: PropTypes.object,
      isCaptured: PropTypes.bool,
      authorisedAt: PropTypes.string
    }),
    requestType: PropTypes.string,
    open: PropTypes.bool,
    updateRequestRun: PropTypes.func.isRequired,
    locked: PropTypes.bool,
    onClick: PropTypes.func,
    saveProgress: PropTypes.func.isRequired,
    singleItemCondensedView: PropTypes.bool,
    editAllowedAfterInitialCapture: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    open: false
  }

  render() {
    let { requestRun, requestType, open, updateRequestRun, locked, onClick, saveProgress, singleItemCondensedView, editAllowedAfterInitialCapture, className } = this.props
    let isCaptured = requestRun.isCaptured

    return (
      <ExpandableOverviewItem
        title='Capture'
        summary={requestRun.capturedBy
          ? `${requestRun.capturedBy.firstName} ${requestRun.capturedBy.lastName}`
          : ''
        }
        iconSymbol={isCaptured ? 'check' : null}
        iconColour={isCaptured ? 'success' : null}
        open={open}
        locked={locked}
        onClick={onClick}
        singleItemCondensedView={singleItemCondensedView}
        className={className}>
        <div className='slds-m-left_small slds-m-bottom_large'>
          <RequestCaptureForm
            requestRun={requestRun}
            requestType={requestType}
            updateRequestRun={updateRequestRun}
            saveProgress={saveProgress}
            editAllowed={editAllowedAfterInitialCapture}
          />
        </div>
      </ExpandableOverviewItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/request-capture/index.js